module.exports = __webpack_public_path__ + "img/snow.65f4bce7.svg";